module.exports = __webpack_public_path__ + "img/P4-3-2.33b8dd96.svg";